import { FormQuestionType } from '@atlassian/proforma-form-renderer/proforma-form';

export const isUserField = (type: FormQuestionType): boolean =>
	type === FormQuestionType.UserMultiple || type === FormQuestionType.UserSingle;
